import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { postData1, postProductData, fetchMedicalCategories, getSpecialityLists, getSeoByref, createSeo, updateSeo, getSlugByProduct, updateSlugByProduct, CreateSlugForProduct, getHsnCode, reorderImages, getTaxes } from "../../../services";
import { productStatus } from "../../MappedData";
import { UsersAddress } from "../../../utils/UsersAddress";
import AutoImageSlider from "../../../components/AutoImageSlider";
import axios from "axios";
import { MdDelete } from "react-icons/md";
import { user } from "../../assets/img";
import MultiSelect from "./MultiSelect";


export const EquipForm = () => {
  const [formDisabled, setFormDisabled] = useState(true);
  const [isOpen, setOpen] = useState(false);

  const location = useLocation();
  const productId = location.state?.productId;
  // console.log("Product ID from location state:", productId);
  const [userData, setUserData] = useState(null);

  const [currStatus, setStatus] = useState(userData?.product_status);
  // const [imgs, setImgs] = useState(userData?.product_images);
  const [imgPointer, setImgPointer] = useState(0);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [videoPointer, setVideoPointer] = useState(0);
  // const [videos, setVideos] = useState(userData?.product_video);
  const [imgs, setImgs] = useState([]);
  const [videos, setVideos] = useState([]);

  const [loading, setLoading] = useState(false);
  const [usersAddress, setUsersAddress] = useState({
    seller: "",
  });
  const [categories, setCategories] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [metaData, setMetaData] = useState({
    uid: '',
    title: '',
    description: '',
    reference_id: userData?.uid,
    keywords: '',
    type: 'product'
  });

  const [slug, setSlug] = useState(null);
  const [editSlug, setEditSlug] = useState("");
  const [hsnList, setHsnList] = useState([]);
  const [taxsList, setTaxsList] = useState([]);
  const [imageOrders, setImageOrders] = useState([]);


  const fetchSlug = async () => {
    try {
      setLoading(true);
      const res = await getSlugByProduct(userData?.id);
      if (res) {
        setSlug(res);
        setEditSlug(res.slug ?? "");  // Automatically update input
      }
    } catch (error) {
      console.error("Error fetching slug:", error);
    } finally {
      setLoading(false);
    }
  };

  // console.log("Slug data:", userData);
  const handleUpdateSlug = async () => {
    try {
      if (!slug?.id) {
        const slugPayload = {
          product: userData?.id,
          slug: editSlug,
          is_active: true

        }

        await CreateSlugForProduct(slugPayload);
        toast.success("Slug created successfully");
      } else {

        await updateSlugByProduct(slug.id, { slug: editSlug });
        toast.success("Slug updated successfully");
        // update original slug locally

      }
      setSlug((prev) => ({ ...prev, slug: editSlug }));

    } catch (error) {
      console.error(error);
      toast.error("Failed to update slug");
    }
  };




  const fetchProduct = async () => {
    try {
      const res = await postData1("admin/product_detail/", { product_id: productId, },
        true,
        true
      );

      if (res?.data) {


        setUserData(res?.data);
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to load product");
    }
  };



  useEffect(() => {
    if (productId) {
      fetchProduct();
    }
  }, [productId]);

  useEffect(() => {
    if (userData) {
      setImgs(userData?.product_images || []);
      setVideos(userData?.product_video || []);
      setStatus(userData?.product_status);
    }
  }, [userData]);

  useEffect(() => {
    if (userData?.id) {
      fetchSlug();
    }
  }, [userData?.id]);



  //seo functions 

  const handleSubmitMeta = async () => {
    try {
      const res = await createSeo(metaData);
      if (res) {

        setMetaData({
          uid: res.uid,
          title: res.title,
          description: res.description,
          keywords: res.keywords,

        }); // save returned object (with id)
        toast.success("Metadata created successfully");

      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateMeta = async () => {
    try {
      if (!metaData.uid) return; // must have id for update
      const res = await updateSeo(metaData.uid, metaData);
      if (res) {
        setMetaData(
          {
            uid: res?.uid,
            title: res.title,
            description: res.description,
            keywords: res.keywords,
          }
        );
        toast.success("Metadata updated successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSeo = async () => {
    try {
      if (!userData?.uid) return;

      const res = await getSeoByref(userData?.uid);

      if (res && res.length > 0) {
        setMetaData({
          uid: res[0].uid,
          title: res[0].title,
          description: res[0].description,
          reference_id: res[0]?.reference_id,
          keywords: res[0].keywords,
          type: res[0].type,
        });
      }

    } catch (error) {
      console.error(error);
    }
  }

  // useEffect(() => { fetchSeo() }, [])
  useEffect(() => {
    if (userData?.uid) {
      fetchSeo();
    }
  }, [userData?.uid]);
  // ===========

  useEffect(() => {
    if (userData?.uid) {
      setMetaData(prev => ({
        ...prev,
        reference_id: userData.uid,
        type: "product"
      }));
    }
  }, [userData?.uid]);


  UsersAddress({
    seller: userData?.user,
    setUsersAddress,
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      // Provide safe defaults for all fields
      equpName: userData?.equip_name || "",
      address: userData?.address || "",
      cond: userData?.equip_condition || "",
      askPrice: userData?.asking_price ? Number(userData.asking_price).toFixed(2) : "",
      negotiableType: userData?.negotiable_type || "",
      desc: userData?.description || "",
      mfYear: userData?.date || "",
      brand: userData?.brand || "",
      model: userData?.model || "",
      warranty: userData?.warranty ?? false,
      amc: userData?.existing_amc ?? false,
      other: userData?.other_details || "",
      sellerFname: userData?.seller_firstname || "",
      sellerLname: userData?.seller_lastname || "",
      shipingFrom: usersAddress?.seller?.address || "",
      userNumber: userData?.seller_mobile || "",
      installation_price: userData?.installation_price || "",
      isDemoable: userData?.others?.isDemoable || "0",
      // ID based fields - these are the ONLY source for Category, Sub Category and Speciality.
      catog: Array.isArray(userData?.department_categories)
        ? userData.department_categories.map(Number).filter(Number.isFinite)
        : [],

      subCategory: Array.isArray(userData?.subcategories)
        ? userData.subcategories.map(Number).filter(Number.isFinite)
        : [],

      spec: Array.isArray(userData?.specialities)
        ? userData.specialities.map(Number).filter(Number.isFinite)
        : [],

      department_categories: Array.isArray(userData?.department_categories)
        ? userData.department_categories.map(Number).filter(Number.isFinite)
        : [],

      subcatory_lists: Array.isArray(userData?.subcategories)
        ? userData.subcategories.map(Number).filter(Number.isFinite)
        : [],

      specility_ids: Array.isArray(userData?.specialities)
        ? userData.specialities.map(Number).filter(Number.isFinite)
        : [],

      mrp: userData?.others?.mrp || 0,
      askingPriceEnable: userData?.others?.askingPriceEnable || false,
      others: userData?.others || {},
      warrantyMonth: userData?.others?.warrantyMonth,
      warrantyYear: userData?.others?.warrantyYear,
      hsn_code: userData?.others?.hsn_code,
      min_quantity: userData?.min_quantity || 1,
      tax_rate: (() => {
        const stored = userData?.others?.tax_rate;
        if (stored == null || stored === "") return "";
        // find the taxsList item whose tax_rate matches stored value
        const match = taxsList.find(t => Number(t.tax_rate) === Number(stored));
        return match ? String(match.id) : "";
      })(),

      rating: userData?.rating || 0,
      rating_count: userData?.rating_count || 0,

      // NEW: YouTube links
      youtubeLinks: userData?.others?.youtube_links || [],
    },
  });
  // useEffect(() => {
  //   if (usersAddress?.seller) {
  //     formik.setValues({
  //       shipingFrom: usersAddress?.seller?.address,
  //       userNumber: usersAddress?.seller?.mobile,
  //     });
  //   }
  // }, [usersAddress?.seller]);

  const handleProdStatus = (e, key) => {
    let value = e.currentTarget.innerHTML;
    setStatus(key);
    setOpen(false);
  };

  const moveImg1 = (e, isVideo) => {
    e.preventDefault();
    const name = e.currentTarget.name;

    if (isVideo) {
      setVideoPointer((prev) =>
        name === "prev"
          ? (prev === 0 ? videos.length - 1 : prev - 1)
          : (prev === videos.length - 1 ? 0 : prev + 1)
      );
    } else {
      setImgPointer((prev) =>
        name === "prev"
          ? (prev === 0 ? imgs.length - 1 : prev - 1)
          : (prev === imgs.length - 1 ? 0 : prev + 1)
      );
    }
  };
  const moveImg = (e, isVideo) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      isVideo
        ? setVideoPointer(videoPointer === 0 ? 0 : videoPointer - 1)
        : setImgPointer(imgPointer === 0 ? 0 : imgPointer - 1);
    } else {
      isVideo
        ? setVideoPointer(
          videoPointer === videos?.length - 1
            ? videos?.length - 1
            : videoPointer + 1
        )
        : setImgPointer(
          imgPointer === imgs?.length - 1 ? imgs?.length - 1 : imgPointer + 1
        );
    }
  };

  const updateProdcutStatus = async () => {
    const res = await postData1(
      "admin/update_product_status/",
      { product_id: userData?.uid, product_status: currStatus },
      true,
      true
    );
    if (res?.status_code === 200) {
      toast.success("Status update successfully !");
    } else {
      toast.error("Something went wrong, try again !");
    }
  };

  const updateInstallationPrice = async () => {
    let amount = formik.values.installation_price;
    let data = {
      product_id: userData?.id,
      post_type: userData?.post_type,
      installation_price: amount,
    };
    const res = await postData1("product/product/add/", data, true, true);
    if (res?.status_code === 200) {
      toast.success("Price update successfully !");
    } else {
      toast.error("Something went wrong try again !");
    }
  };

  // const [uploadedImages, setUploadedImages] = useState([]);

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const previews = files.map(file => ({
      file,
      url: URL.createObjectURL(file),
    }));
    setUploadedImages(prev => [...prev, ...previews]);
  };

  const handleRemoveImage = (index) => {
    const updated = [...uploadedImages];
    URL.revokeObjectURL(updated[index].url);
    updated.splice(index, 1);
    setUploadedImages(updated);
  };

  const BaseURL = process.env.REACT_APP_BASEURL;
  const handleApplyImages = async () => {
    if (uploadedImages.length === 0) {
      toast.error("Please upload at least one image");
      return;
    }

    // const token = localStorage.getItem("token");
    const formData = new FormData();

    uploadedImages.forEach(img => {
      formData.append('images', img.file); // corrected
    });
    try {
      setLoading(true);
      const response = await axios.post(
        `${BaseURL}/product/product/upload_media/?product_uid=${userData?.uid}`,
        formData,
        {
          headers: {
            Authorization: `token ${localStorage.getItem("adminAuth")}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      // console.log("Upload response:", response.data);
      toast.success("Images uploaded successfully");
      setLoading(false);

      // Optionally reset or update state here
      setUploadedImages([]);
      setImgs(prev => [...prev, ...response.data.images]);

    } catch (error) {
      console.error("Error uploading images:", error);
      toast.error("Failed to upload images");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteImage = async () => {
    if (imgs.length === 0) {
      toast.error("No images to delete");
      return;
    }

    const updatedImgs = imgs.filter((_, idx) => idx !== imgPointer);
    setImgs(updatedImgs);
    setImgPointer((prev) => (prev > 0 ? prev - 1 : 0));
    // Optionally, call API to delete image from backend here
    const token = localStorage.getItem("adminAuth");
    const imageToDelete = imgs[imgPointer]?.id;
    try {
      setLoading(true);
      const response = await axios.post(
        `${BaseURL}/product/product/delete_image/`,
        { id: imageToDelete },
        {
          headers: {
            Authorization: `token ${token}`,
            "Content-Type": "application/json",
            accept: "application/json",
          },
        }
      );
      if (response?.data?.status_code === 200) {
        toast.success("Image deleted successfully");
      } else {
        toast.error("Failed to delete image");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      toast.error("Error deleting image");
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetchMedicalCategories();
      if (response?.data) {
        // console.log("Fetched categories:", response?.data?.data);
        setCategories(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  const fetchSpeciality = async () => {
    try {
      const response = await getSpecialityLists();

      setSpecialities(response?.data);

    } catch (error) {
      console.error("Error fetching speciality:", error);
    }
  };

  // console.log("Categories:", categories);
  const fetchHsnCode = async () => {
    try {
      const res = await getHsnCode();
      // console.log(res)
      setHsnList(res || []);
    } catch (err) {
      toast.error('Failed to fetch HSN codes');
    }
  };
  const fetchTaxes = async () => {
    try {
      const res = await getTaxes();
      // console.log(res)
      setTaxsList(res || []);
    } catch (err) {
      toast.error('Failed to fetch HSN codes');
    }
  };

  useEffect(() => {
    fetchHsnCode();
    fetchCategories();
    fetchSpeciality();
    fetchTaxes();
  }, []);



  // console.log(taxsList);

  // --- YouTube Links helpers ---
  const handleYoutubeLinkChange = (index, value) => {
    const updated = [...formik.values.youtubeLinks];
    updated[index] = value;
    formik.setFieldValue('youtubeLinks', updated);
  };

  const addYoutubeLink = () => {
    const updated = [...formik.values.youtubeLinks, ''];
    formik.setFieldValue('youtubeLinks', updated);
  };

  const removeYoutubeLink = (index) => {
    const updated = formik.values.youtubeLinks.filter((_, i) => i !== index);
    formik.setFieldValue('youtubeLinks', updated);
  };
  // --- End YouTube helpers ---

  const toIdArray = (value) => {
    if (!Array.isArray(value)) return [];

    return [...new Set(
      value
        .map(Number)
        .filter(Number.isFinite)
    )];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userData?.id) {
      toast.error("Product data is not loaded yet");
      return;
    }

    const userDetails = {
      product_id: userData.id,
      post_type: userData.post_type,
    };

    // Category / Sub Category / Speciality are ID based only.
    const categoryIds = toIdArray(formik.values.catog);
    const subCategoryIds = toIdArray(formik.values.subCategory);
    const specialityIds = toIdArray(formik.values.spec);

    // Generate display names ONLY at submit time from selected IDs.
    // Names are derived from the selected IDs only.
    const categoryNames = categories
      .filter(item => categoryIds.includes(Number(item.id)))
      .map(item => item.name);

    const subCategoryNames = subcategories
      .filter(item => subCategoryIds.includes(Number(item.id)))
      .map(item => item.name);

    const specialityNames = specialities
      .filter(item => specialityIds.includes(Number(item.id)))
      .map(item => item.name);

    const payload = {
      ...formik.values,

      seller_firstname: formik.values.sellerFname,
      seller_lastname: formik.values.sellerLname,
      amc: formik.values.amc ? 1 : 0,

      // Names are derived from IDs, never used as the source of truth.
      catog: categoryNames,
      subCategory: subCategoryNames,
      spec: specialityNames.join(","),

      // IDs sent to backend.
      department_categories: categoryIds,
      subcatory_lists: subCategoryIds,
      specility_ids: specialityIds,

      others: {
        ...formik.values.others,
        youtube_links: formik.values.youtubeLinks,
        tax_rate: (() => {
          const selectedId = Number(formik.values.tax_rate);
          const match = taxsList.find(t => t.id === selectedId);
          return match ? Number(match.tax_rate) : 0;
        })(),
      },
    };

    // console.log("CATEGORY/SUBCATEGORY/SPECIALITY IDS:", {
    //   department_categories: categoryIds,
    //   subcatory_lists: subCategoryIds,
    //   specility_ids: specialityIds,
    // });

    try {
      setLoading(true);
      const res = await postProductData(userDetails, payload);

      if (res?.status_code === 200) {
        toast.success("Data Updated Successfully!");
        await fetchProduct();
      } else {
        toast.error("Failed to update product");
      }

      console.log("Form submitted successfully:", res);
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit form");
    } finally {
      setLoading(false);
    }
  };

  const subcategories = useMemo(
    () => categories.flatMap(category => category?.subcategories || []),
    [categories]
  );


  // meta details

  const metaHandleChange = (e) => {
    const { name, value } = e.target;
    setMetaData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (imgs?.length) {
      setImageOrders(
        imgs.map(img => ({
          id: img.id,
          order: null, // user decides
        }))
      );
    }
  }, [imgs]);


  const handleOrderChange = (imageId, value) => {
    const orderValue = value === "" ? null : Number(value);

    setImageOrders(prev =>
      prev.map(img =>
        img.id === imageId ? { ...img, order: orderValue } : img
      )
    );
  };

  const ImageReorder = async (e) => {
    e.preventDefault();

    const payload = imageOrders
      .filter(img => img.order !== null)
      .map(img => ({
        id: img.id,
        order: img.order,
      }));

    if (!payload.length) {
      toast.error("Please assign order to at least one image");
      return;
    }

    try {
      const res = await reorderImages(payload);
      if (res) {
        toast.success("Images Updated Successfully!");
      }
    } catch (error) {
      console.error("Error", error);
      toast.error("Failed to reorder images");
    }
  };

  return (
    <>
      <section className="w-full bg-white px-4 py-8 lg:py-12 rounded-2xl shadow-lg max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-blue-800">Equipment Details</h2>
          <p className="text-gray-600">View and manage product information</p>
        </div>

        <div>
          <h2 className="text-3xl font-bold text-blue-800">Meta Section</h2>
          <div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
              <input
                type="text"
                name="title"
                value={metaData.title}
                onChange={metaHandleChange}

                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Keywords</label>
              <input
                type="text"
                name="keywords"
                value={metaData.keywords}
                onChange={metaHandleChange}

                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea

                name="description"
                value={metaData.description}
                onChange={metaHandleChange}

                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              />
            </div>
            <div className="w-full flex item-center justify-end py-2">
              {metaData.uid ? <button
                className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition"
                onClick={handleUpdateMeta}
              >Update</button> :
                <button
                  className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition"
                  onClick={handleSubmitMeta}
                >Submit</button>
              }
            </div>

          </div>

        </div>

        <form
          className="bg-white p-8 rounded-xl shadow-lg grid grid-cols-1 md:grid-cols-2 gap-6"
          onSubmit={handleSubmit}
        >
          <h2 className="md:col-span-2 text-2xl font-semibold text-gray-800 border-b pb-2 mb-2">
            Equipment Information
          </h2>

          {[
            { label: "Equipment Name", name: "equpName", type: "text" },
            { label: "Seller First Name", name: "sellerFname", type: "text" },
            { label: "Seller Last Name", name: "sellerLname", type: "text" },
            { label: "Mobile Number", name: "userNumber", type: "text", valueKey: "userNumber" },
            { label: "Address", name: "address", type: "text" },
            // { label: "Asking Price", name: "askPrice", type: "number" },
            ...(userData?.post_type === 1
              ? [{ label: "Manufacturing Year", name: "mfYear", type: "text" }]
              : []),
            { label: "Brand/Company", name: "brand", type: "text" },
            { label: "Model Number", name: "model", type: "text" },
          ].map((field, idx) => (
            <div key={idx}>
              <label className="block text-sm font-medium text-gray-700 mb-1">{field.label}</label>
              <input
                type={field.type}
                name={field.name}
                value={field.value || formik.values[field.valueKey || field.name]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              />
            </div>
          ))}



          {/* pricing  */}
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-start gap-2 mt-8">
              <input
                id="ask-pricing"
                type="checkbox"
                name="askingPriceEnable"
                className="w-5 h-5 rounded-sm border-gray-300"
                checked={Boolean(formik.values.askingPriceEnable)}
                onChange={(e) => {
                  // when enabling "Ask pricing", clear asking_price and mrp (or keep if you prefer)
                  const isEnabled = e.target.checked;
                  formik.setFieldValue('askingPriceEnable', isEnabled);
                  if (isEnabled) {
                    formik.setFieldValue('asking_price', 0);
                    formik.setFieldValue('mrp', 0);
                  }
                }}
              />
              <label htmlFor="ask-pricing" className="mb-1 font-medium">
                Ask pricing enable
              </label>
            </div>

            {/* Show numeric price fields only when askingPriceEnable is false */}
            {!formik.values.askingPriceEnable && (
              <>
                <div>
                  <label className="block mb-1 font-medium">Selling Price</label>
                  <input
                    type="number"
                    name="askPrice"
                    className="w-full border rounded px-3 py-2"
                    placeholder="Price"
                    // show blank string if 0 to avoid showing 0 — change behavior if you want 0
                    value={formik.values.askPrice ? Math.round(formik.values.askPrice) : ''}
                    onChange={(e) => {
                      // allow empty string -> set 0; or set parsed number
                      const raw = e.target.value;
                      formik.setFieldValue('askPrice', raw === '' ? 0 : Number(raw));
                    }}
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium">MRP</label>
                  <input
                    type="number"
                    name="mrp"
                    className="w-full border rounded px-3 py-2"
                    placeholder="MRP"
                    value={formik.values.mrp ? formik.values.mrp : ''}
                    onChange={(e) => {
                      const raw = e.target.value;
                      formik.setFieldValue('mrp', raw === '' ? 0 : Number(raw));
                    }}
                  />
                </div>
              </>
            )}
          </div>

          {/* Radio Inputs */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Equipment Condition</label>
            <div className="flex flex gap-2">
              {[
                { label: "Good", value: 1 },
                { label: "Excellent", value: 2 },
                { label: "As Good as New", value: 3 },
              ].map(opt => (
                <label key={opt.value} className="inline-flex items-center gap-2">
                  <input
                    type="radio"
                    name="cond"
                    value={opt.value}
                    checked={formik.values.cond === opt.value}
                    onChange={() => formik.setFieldValue("cond", opt.value)}
                    className="text-blue-600 focus:ring-blue-500"
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>


          {/* Tax */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tax
            </label>

            <select
              name="tax_rate"
              className="w-full border rounded px-3 py-2 bg-white"
              value={formik.values.tax_rate ?? ''}
              onChange={(e) =>
                formik.setFieldValue('tax_rate', e.target.value)
              }
            >
              <option value="" disabled>
                Select Tax
              </option>

              {taxsList.map((item) => (
                <option key={item.id} value={String(item.id)}>
                  {item.tax_rate}%
                </option>
              ))}
            </select>

          </div>

          {/* hsn code  */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              HSN Code
            </label>
            <select
              name="hsn_code"
              className="w-full border rounded px-3 py-2 bg-white"
              value={formik.values.hsn_code || ''}
              onChange={(e) =>
                formik.setFieldValue('hsn_code', Number(e.target.value))
              }
            >
              <option value="" disabled>
                Select HSN Code
              </option>

              {hsnList.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.code} ({item.percent}%)
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Price Type</label>
            <div className="flex flex gap-2">
              {[
                { label: "Negotiable", value: 1 },
                { label: "Slightly Negotiable", value: 2 },
                { label: "Non-Negotiable", value: 3 },
              ].map(opt => (
                <label key={opt.value} className="inline-flex items-center gap-2">
                  <input
                    type="radio"
                    name="negotiableType"
                    value={opt.value}
                    checked={formik.values.negotiableType === opt.value}
                    onChange={() => formik.setFieldValue("negotiableType", opt.value)}
                    className="text-blue-600 focus:ring-blue-500"
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Under Warranty</label>
            <div className="flex gap-4">
              {[
                { label: "Yes", value: 1 },
                { label: "No", value: 0 },
              ].map(opt => (
                <label key={String(opt.value)} className="inline-flex items-center gap-2">
                  <input
                    type="radio"
                    name="warranty"
                    value={String(opt.value)}
                    checked={formik.values.warranty === opt.value}
                    onChange={() => formik.setFieldValue("warranty", opt.value)}
                    className="text-blue-600 focus:ring-blue-500"
                  />
                  {opt.label}
                </label>
              ))}
            </div>

            {/* month year */}
            <div className=''>
              {formik.values.warranty === 1 && (
                <div className="mt-4 flex items-center justify-around">
                  <input
                    type='text'
                    value={
                      (Number(formik.values.warrantyMonth) || 0) + " Month" +
                      " " +
                      (Number(formik.values.warrantyYear) || 0) + " Year"
                    }
                    readOnly
                  />
                  {/* Warranty Month */}
                  <div>
                    {/* <label className="block mb-1 font-medium">Warranty Month</label> */}
                    <select
                      className="w-full border rounded px-3 py-2"
                      value={formik.values.warrantyMonth}
                      onChange={e => formik.setFieldValue("warrantyMonth", Number(e.target.value))}
                    >
                      <option value="" disabled>Select Month</option>
                      {[...Array(12)].map((_, i) => (
                        <option key={i} value={i}>
                          {i} Month
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Warranty Year */}
                  <div>
                    {/* <label className="block mb-1 font-medium mt-4">Warranty Year</label> */}
                    <select
                      className="w-full border rounded px-3 py-2"
                      value={formik.values.warrantyYear}
                      onChange={e => formik.setFieldValue("warrantyYear", Number(e.target.value))}
                    >
                      <option value="" disabled>Select Year</option>
                      {[0, 1, 2, 3, 4, 5].map(year => (
                        <option key={year} value={year}>
                          {year} Year
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Existing AMC/CMC</label>
            <div className="flex gap-4">
              {[
                { label: "Yes", value: 1 },
                { label: "No", value: 0 },
              ].map(opt => (
                <label key={String(opt.value)} className="inline-flex items-center gap-2">
                  <input
                    type="radio"
                    name="amc"
                    value={String(opt.value)}
                    checked={formik.values.amc === opt.value}
                    onChange={() => formik.setFieldValue("amc", opt.value)}
                    className="text-blue-600 focus:ring-blue-500"
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Demoable</label>
            <div className="flex gap-4">
              {[{ label: "Yes", value: "1" }, { label: "No", value: "0" }].map(opt => {
                const id = `isDemoable-${opt.value}`;
                return (
                  <label key={id} htmlFor={id} className="inline-flex items-center gap-2">
                    <input
                      id={id}
                      type="radio"
                      name="isDemoable"
                      value={opt.value}
                      checked={String(formik.values.isDemoable) === opt.value}
                      onChange={() => formik.setFieldValue("isDemoable", opt.value)}
                      className="text-blue-600 focus:ring-blue-500"
                    />
                    {opt.label}
                  </label>
                );
              })}

            </div>
          </div>

          {/* Category & Speciality MultiSelect */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
            <MultiSelect
              name="catog"
              options={categories?.map(c => ({ value: Number(c.id), label: c.name })) || []}
              selectedValues={formik.values.catog}
              onChange={formik.setFieldValue}
              placeholder="Select categories"
              idField="department_categories"
              idAsArray={true}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Sub Category</label>
            <MultiSelect
              name="subCategory"
              options={subcategories?.map(c => ({ value: Number(c.id), label: c.name })) || []}
              selectedValues={formik.values.subCategory}
              onChange={formik.setFieldValue}
              placeholder="Select subcategories"
              idField="subcatory_lists"
              idAsArray={true}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Speciality</label>
            <MultiSelect
              name="spec"
              options={specialities?.map(s => ({ value: Number(s.id), label: s.name })) || []}
              selectedValues={formik.values.spec}
              onChange={formik.setFieldValue}
              placeholder="Select specialities"
              idField="specility_ids"
              idAsArray={true}
            />
          </div>

          {/* Textareas */}
          {[
            { label: "Other Details", name: "other" },
            ...(userData?.post_type === 1 ? [{ label: "Description", name: "desc" }] : [])
          ].map((field, idx) => (
            <div key={idx} className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">{field.label}</label>
              <textarea
                name={field.name}
                value={formik.values[field.name]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              ></textarea>
            </div>
          ))}

          {/* NEW: YouTube Links Section */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              YouTube Links
            </label>
            {formik.values.youtubeLinks.map((link, index) => (
              <div key={index} className="flex items-center gap-2 mb-2">
                <input
                  type="url"
                  value={link}
                  onChange={(e) => handleYoutubeLinkChange(index, e.target.value)}
                  placeholder="https://www.youtube.com/watch?v=..."
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                />
                <button
                  type="button"
                  onClick={() => removeYoutubeLink(index)}
                  className="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={addYoutubeLink}
              className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              + Add YouTube Link
            </button>
          </div>

          <div className="md:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              {/* Minimum Quantity */}
              <div className="w-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Minimum Quantity to Sell
                </label>

                <input
                  type="number"
                  name="min_quantity"
                  min={1}
                  value={formik.values.min_quantity ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;

                    if (val === "") {
                      formik.setFieldValue("min_quantity", "");
                      return;
                    }

                    const num = Math.max(1, Number(val));
                    formik.setFieldValue("min_quantity", num);
                  }}
                  onBlur={() => {
                    if (!formik.values.min_quantity || formik.values.min_quantity < 1) {
                      formik.setFieldValue("min_quantity", 1);
                    }
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                />

                <p className="text-xs text-gray-500 mt-1">
                  User must buy at least this quantity
                </p>
              </div>

              {/* Rating */}
              <div className="w-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Rating (0-5)
                </label>

                <input
                  type="number"
                  name="rating"
                  step="0.1"
                  min={0}
                  max={5}
                  value={formik.values.rating ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;

                    if (val === "") {
                      formik.setFieldValue("rating", "");
                      return;
                    }

                    const num = Math.min(5, Math.max(0, Number(val)));
                    formik.setFieldValue("rating", num);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>

              {/* Rating Count (FULL WIDTH) */}
              <div className=" w-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Rating Count
                </label>

                <input
                  type="number"
                  name="rating_count"
                  min={0}
                  value={formik.values.rating_count ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;

                    if (val === "") {
                      formik.setFieldValue("rating_count", "");
                      return;
                    }

                    const num = Math.max(0, Number(val));
                    formik.setFieldValue("rating_count", num);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>

            </div>
          </div>

          <div className="md:col-span-2 flex justify-end">

            <button
              type="submit"
              className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition"
            >
              Submit
            </button>
          </div>
        </form>


        {/* Image Section */}
        <div className="mt-10">
          <h3 className="text-xl font-semibold mb-2 text-gray-700">Images</h3>
          <div className="flex items-center justify-center gap-4">
            <button
              name="prev"
              onClick={(e) => moveImg1(e, 0)}
              className="text-blue-500 hover:text-blue-700"
            >
              ◀️
            </button>
            <div className=" relative ">
              <div
                className="w-60 h-40 bg-cover bg-center rounded-lg shadow"
                style={{ backgroundImage: `url(${imgs[imgPointer]?.p_image})` }}
              ></div>
              <button
                onClick={() => {
                  handleDeleteImage()

                  // Optionally, call API to delete image from backend here

                }}
                className="absolute top-2 right-2 bg-white rounded-full p-1 shadow hover:bg-red-100 transition"
                title="Delete Image"
                style={{ zIndex: 10 }}
              >
                <MdDelete className="text-red-600 text-xl hover:text-red-800" />
              </button>
            </div>
            <button
              name="next"
              onClick={(e) => moveImg1(e, 0)}
              className="text-blue-500 hover:text-blue-700"
            >
              ▶️
            </button>
          </div>
          <p className="text-sm text-center text-gray-500 mt-1">
            {imgPointer + 1}/{imgs.length}
          </p>
        </div>
        <div className=" w-full mt-6 ">
          <AutoImageSlider images={imgs} />
        </div>

        <div className="mt-10">
          <h3 className="text-xl font-semibold mb-4 text-gray-700">
            Image Reorder
          </h3>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {imgs.map((img, index) => {
              const currentOrder = imageOrders.find(i => i.id === img.id)?.order ?? "";

              return (
                <div
                  key={img.id}
                  className="border rounded-lg p-2 flex flex-col items-center gap-2 bg-gray-50 shadow-sm"
                >
                  <img
                    src={img.p_image}
                    alt={`img-${index}`}
                    className="w-24 h-20 object-cover rounded"
                  />

                  <select
                    value={currentOrder}
                    onChange={(e) => handleOrderChange(img.id, e.target.value)}
                    className="w-full border rounded text-sm px-2 py-1"
                  >
                    <option value="">No Order</option>
                    {imgs.map((_, i) => (
                      <option key={i} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </div>
              );
            })}
          </div>

          <div className="flex justify-end mt-6">
            <button
              onClick={ImageReorder}
              className="px-6 py-2 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition"
            >
              Update Image Order
            </button>
          </div>
        </div>



        {/* Video Section */}
        {videos.length > 0 && (
          <div className="mt-10">
            <h3 className="text-xl font-semibold mb-2 text-gray-700">Videos</h3>
            <div className="flex items-center gap-4">
              <button onClick={(e) => moveImg(e, 1)} className="text-blue-500 hover:text-blue-700">
                ◀️
              </button>
              {/* {console.log("first", videos[videoPointer].video)} */}
              <video className="w-60 h-40 rounded-lg shadow" controls>
                <source src={videos[videoPointer]?.video} type="video/mp4" />
              </video>
              <button onClick={(e) => moveImg(e, 1)} className="text-blue-500 hover:text-blue-700">
                ▶️
              </button>
            </div>
            <p className="text-sm text-center text-gray-500 mt-1">
              {videoPointer + 1}/{videos.length}
            </p>
          </div>
        )}

        {/* Product Action Section */}
        <div className="mt-12 border-t pt-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Actions</h3>
          <div className="flex flex-col md:flex-row gap-6">
            <div className="w-full md:w-1/2">
              <label className="text-sm font-medium text-gray-600">Installation Cost</label>
              <div className="flex items-center mt-1 gap-2">
                <input
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  placeholder="Enter cost"
                  name="installation_price"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.installation_price}
                />
                <button
                  onClick={updateInstallationPrice}
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Apply
                </button>
              </div>
            </div>

            <div className="w-full md:w-1/2">
              <label className="text-sm font-medium text-gray-600">Product Status</label>
              <div className=" flex flex-row items-center justify-between w-full">
                <div className="relative mt-1 w-full mr-6">
                  <button
                    onClick={() => setOpen(!isOpen)}
                    className="w-full text-left px-3 py-2 border border-gray-300 rounded-md bg-white shadow"
                  >
                    {productStatus[currStatus]} <i className="bi bi-chevron-down float-right"></i>
                  </button>
                  {isOpen && (
                    <div className="absolute mt-1 bg-white shadow-lg border rounded-md z-10 w-full max-h-40 overflow-y-auto">
                      {Object.keys(productStatus).map((key, index) => (
                        <div
                          key={index}
                          onClick={(e) => handleProdStatus(e, key)}
                          className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                        >
                          {productStatus[key]}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <button
                  onClick={updateProdcutStatus}
                  className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
          <div className="w-full  flex items-start flex-row mt-10">
            <h3 className="text-lg font-bold text-gray-800 mb-2">Upload Images</h3>

            {/* Upload Input */}
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handleImageUpload}
              className="block w-full text-sm text-gray-500
      file:mr-4 file:py-2 file:px-4
      file:rounded-md file:border-0
      file:text-sm file:font-semibold
      file:bg-blue-50 file:text-blue-700
      hover:file:bg-blue-100"
            />

            <div className="flex justify-end ">
              <button
                disabled={loading}
                onClick={handleApplyImages}
                className="px-6 py-2 bg-green-600 text-white rounded-md font-semibold hover:bg-green-700 transition duration-300 shadow"
              >
                {loading ? "Applying..." : "Apply"}
              </button>
            </div>
            {/* Image Preview */}
          </div>
          {uploadedImages.length > 0 && (
            <>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-4">
                {uploadedImages.map((img, idx) => (
                  <div key={idx} className="relative group border rounded-lg overflow-hidden shadow-sm">
                    <img
                      src={img.url}
                      alt={`upload-${idx}`}
                      className="w-full h-36 object-cover"
                    />
                    <button
                      onClick={() => handleRemoveImage(idx)}
                      className="absolute top-1 right-1 bg-red-600 text-white rounded-full w-6 h-6 text-xs flex items-center justify-center opacity-90 hover:opacity-100"
                      title="Remove"
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>

              {/* Apply Button */}
              {/* <div className="flex justify-end mt-6">
        <button
          onClick={handleApplyImages}
          className="px-6 py-2 bg-green-600 text-white rounded-md font-semibold hover:bg-green-700 transition duration-300 shadow"
        >
          Apply
        </button>
      </div> */}
            </>
          )}



        </div>

        {/* Edit slug  */}

        <div className="mt-4">
          <h2 className="text-xl font-bold text-blue-800">Edit Slug</h2>

          {loading ? (
            <p className="text-gray-500 mt-2">Loading slug...</p>
          ) : (
            <div className="mt-2">
              <input
                type="text"
                value={editSlug}
                onChange={(e) => setEditSlug(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              />

              <button
                onClick={handleUpdateSlug}
                disabled={!editSlug.trim()}
                className={`mt-3 px-6 py-3 rounded-lg shadow-md text-white transition
          ${editSlug.trim()
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-gray-400 cursor-not-allowed"}
        `}
              >
                Update Slug
              </button>
            </div>
          )}
        </div>

      </section>


    </>

  );
};